import script from "./FarmsCollection.vue?vue&type=script&setup=true&lang=js"
export * from "./FarmsCollection.vue?vue&type=script&setup=true&lang=js"

export default script